import React from "react";
import { useParams } from "react-router-dom";
import { EvtHeader } from "components/header";
import ApplicantForm from "../form";

export default function UpdateOpeningApplicant() {
  const { openingId, applicantId } = useParams();
  return (
    <div className="flex-1">
      <EvtHeader title="Edit Applicant" />
      <div className="max-w-md p-4 lg:p-6">
        <ApplicantForm openingId={openingId} applicantId={applicantId} />
      </div>
    </div>
  );
};
